import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LogRocket from 'logrocket';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import routes from './routing';
import { getLogRocketId } from './shared/env-vars';

LogRocket.init(getLogRocketId(), {
  network: {
    isEnabled: false, // disable logging network requests
  },
  dom: {
    inputSanitizer: true, // sanitize input fields
    privateAttributeBlocklist: ['data-exclude-lg'], // disable logging elements with this data attribute
  },
});

const router = createBrowserRouter(routes);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
